import api from '@/services/api';
import { Charge } from '@/types/charge';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chargeKeys } from './use-charges';
import { enrollmentKeys } from './use-enrollments';
import { PROCESSING_METHOD } from '@/types/processing-method';

export interface ManualChargePayload {
  enrollmentId: string;
  amount: number;
  /** ISO date string (yyyy-MM-dd) */
  dueDate: string;
  isManual?: boolean;
  processingMethod?: PROCESSING_METHOD;
  pixCopyPaste?: string;
  paymentLink?: string;
  // Campos extras para cobranças manuais
  description?: string;
  bankName?: string;
  bankAgency?: string;
  bankAccount?: string;
  paymentInstructions?: string;
}

export function useManualCharge() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ManualChargePayload) => {
      const response = await api.post<Charge>('/charge/manual', payload);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: chargeKeys.all });
      if (data?.id) {
        queryClient.invalidateQueries({ queryKey: chargeKeys.detail(data.id) });
      }
      if (data?.enrollmentId) {
        queryClient.invalidateQueries({
          queryKey: chargeKeys.byEnrollment(data.enrollmentId),
        });
        queryClient.invalidateQueries({
          queryKey: enrollmentKeys.detail(data.enrollmentId),
        });
        queryClient.invalidateQueries({ queryKey: enrollmentKeys.provider() });
      }
    },
  });
}
